import { Injectable, Optional } from '@angular/core';
import { routerReducer } from '@ngrx/router-store';
import { Action, combineReducers, Store } from '@ngrx/store';
import * as Enumerable from 'linq';

export type dispatch = Action | Action[];

export function toSubActionPayload(action): Action {
  return action.payload as Action;
}

@Injectable({ providedIn: 'root' })
export class StoreService {
  private _reducers: any = {
    router: routerReducer
  };

  constructor(public store: Store<any>) { }

  public dispatch(action: dispatch) {
    if (action instanceof Array) {
      for (let i = 0; i < action.length; i++) {
        this.store.dispatch(action[i]);
      }
    } else {
      this.store.dispatch(action);
    }
  }

  public static replace<T>(items: T[], item: T, index) {
    const newItems = index === -1 ? [...items, item] : [...items.slice(0, index), item, ...items.slice(index + 1)];

    return newItems;
  }

  public static sortArrayObject<T>(source: T[], propertyName: string) {
    if (!source?.length) return source;

    source = [...source];

    const type = typeof source[0][propertyName];
    if (type === 'string')
      return source.sort(
        (a: T, b: T) => (a[propertyName] && b[propertyName] ? a[propertyName].localeCompare(b[propertyName]) : true)
      );
    if (type === 'number')
      return source.sort(
        (a: T, b: T) =>
          a[propertyName] && b[propertyName]
            ? a[propertyName] < b[propertyName] ? -1 : a[propertyName] > b[propertyName] ? 1 : 0
            : 0
      );
    return source;

  }

  public static replaceIfAny<T>(items: T[], item: T, predicate: (element: T, index: number) => boolean) {
    const index = Enumerable.from(items).indexOf(predicate);

    const newItems = index === -1 ? [...items, item] : [...items.slice(0, index), item, ...items.slice(index + 1)];

    return newItems;
  }
}
